import { combineReducers } from "redux";
import { informativo } from "./informativo/reducer";
import { manifestacoes } from "./manifestacoes/reducer";
import { pontosessenciais } from "./pontosessenciais/reducer";

export const ouvidoria = combineReducers({
  informativo,
  manifestacoes,
  pontosessenciais
});
